import Utils from "@/common/utils/utils";
import { TextField } from "@material-ui/core";
import { I18n } from "aws-amplify";

function EmailInputText({label, emailValue, setEmailValue, required = false, disable = false, fixedDomain = '', setIsEdited, isEmailInput = true, instruction = ''}) {

    const onChangeInputValue = (e) => {
        const value = e.target.value
        setEmailValue({value: value, error: ''})
        setIsEdited(true)
    }

    const onBlurInputValue = (e) => {
        let blurValue = e.target.value.trim()
        if (isEmailInput) {
            blurValue = blurValue.toLowerCase()
        }
        if (required && Utils.isEmptyString(blurValue)) {
            setEmailValue(prev => ({value: blurValue, error: I18n.get('MSG-CM-REQUIRED-INPUT')}))
            return;
        }
        
        if (!isEmailInput && blurValue.length > 2000) {
            setEmailValue(prev => ({value: blurValue, error: I18n.get('MSG-CM-OVER-MAXLENGTH').replace('{{maxLength}}', '2000')}))
            return;
        }
        
        if (isEmailInput) {
            if (blurValue.length > 200) {
                setEmailValue(prev => ({value: blurValue, error: I18n.get('MSG-CM-OVER-MAXLENGTH').replace('{{maxLength}}', '200')}))
                return;
            }
            let validateEmailValue = !Utils.isEmptyString(fixedDomain) ? `${blurValue}${fixedDomain}` : blurValue;
            if (required) {
                if (!Utils.validateEmailVer2(validateEmailValue)) {
                    setEmailValue(prev => ({value: blurValue, error: I18n.get('COMM01MSG07')}))
                    return;
                }
            } else {
                if (!Utils.isEmptyString(validateEmailValue) && !Utils.validateEmailVer2(validateEmailValue)) {
                    setEmailValue(prev => ({value: blurValue, error: I18n.get('COMM01MSG07')}))
                    return;
                }
            }
        }
        setEmailValue(prev => ({value: blurValue, error: ''}))
    }

    return (
        <div className="project-email-setting-group">
            <div className="embeddedCode-label margin-bottom-5">
                <span>{label}</span>
                {required && <span className="required">*</span>}
            </div>
            <div className="email-response-address-input-wrap">
                <TextField
                    fullWidth
                    variant="outlined"
                    className="form-control-wrapInput form-control-hg40 email-response-address-input"
                    value={emailValue.value}
                    onChange={e => onChangeInputValue(e)}
                    onBlur={e => onBlurInputValue(e)}
                    disabled={disable}
                    error={!Utils.isEmptyString(emailValue.error) ? true : false}
                    helperText={emailValue.error}
                />
                {!Utils.isEmptyString(fixedDomain) && (
                    <div className="email-response-fixed-domain-wrap">
                        <p className="email-response-fixed-domain">
                            {fixedDomain}
                        </p>
                    </div>
                )}
            </div>
            {(!Utils.isEmptyString(instruction)) && (
                <p className="email-response-address-instruction">{instruction}</p>
            )}
        </div>
    )
}

export default EmailInputText;